import { hitsPerPage as hitsPerPageWidget } from 'instantsearch.js/es/widgets';

const items = [
  {
    label: '32 résultats par page',
    value: 32,
    default: true,
  },
  {
    label: '64 résultats par page',
    value: 64,
  },
  {
    label: '96 résultats par page',
    value: 96,
  },
];

export const hitsPerPage = hitsPerPageWidget({
  container: '[data-widget="hits-per-page"]',
  items,
});

export function getFallbackHitsPerPageRoutingValue(
  hitsPerPageValue: string
): string | undefined {
  if (
    items.map((item) => item.value).indexOf(Number(hitsPerPageValue)) !== -1
  ) {
    return hitsPerPageValue;
  }

  return undefined;
}
